import React, { useState, useRef } from "react";

// Проверка, является ли ссылка внешней
const isExternalLink = (url) => {
  try {
    const link = new URL(url, window.location.origin);
    return link.origin !== window.location.origin;
  } catch {
    return false; // Если URL невалидный, считаем его внутренним
  }
};

// Проверка, является ли строка base64-закодированной
const isBase64Encoded = (str) => {
  try {
    return btoa(atob(str)) === str;
  } catch {
    return false;
  }
};

// Шифрование ссылки
const encryptLink = (url) => {
  try {
    return btoa(encodeURIComponent(url));
  } catch (error) {
    console.error("Ошибка шифрования ссылки:", url, error);
    return "";
  }
};

// Дешифрование ссылки
const decryptLink = (encryptedUrl) => {
  try {
    if (isBase64Encoded(encryptedUrl)) {
      return decodeURIComponent(atob(encryptedUrl));
    }
    return encryptedUrl;
  } catch {
    console.error("Ошибка расшифровки ссылки:", encryptedUrl);
    return null;
  }
};

// Основной компонент
const LinkHandler = ({ href, children, className, ...props }) => {
  const [isActive, setIsActive] = useState(false); // Состояние активности
  const linkRef = useRef(null); // Ссылка на элемент <a>
  const classLink = "link";

  const handleInternalLink = (e) => {
    e.preventDefault();
    setIsActive(true); // Устанавливаем активное состояние

    if (href === "/") {
      // Прокрутка к самому верху для главной страницы
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      const targetId = href.replace("/", ""); // Убираем слеш для получения ID цели
      const targetElement = document.getElementById(targetId); // Ищем элемент с данным ID
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: "smooth" }); // Плавно скроллим к элементу
      }
    }

    // Снимаем focus и сбрасываем active после завершения
    setTimeout(() => {
      setIsActive(false); // Убираем active
      if (linkRef.current) {
        linkRef.current.blur(); // Снимаем focus
      }
    }, 300);
  };

  if (!href) return null; // Если href пустой, не рендерим ничего

  if (!isExternalLink(href)) {
    // Внутренние ссылки остаются стандартными
    return (
      <a
        href={href}
        onClick={handleInternalLink}
        className={`${className || classLink} ${isActive ? "active" : ""}`.trim()}
        ref={linkRef}
        {...props}
      >
        {children}
      </a>
    );
  }

  // Для внешних ссылок используем <span> с data-url
  const encryptedHref = encryptLink(href);

  const handleClick = (e) => {
    if (e.button === 2) return; // ПКМ - контекстное меню не ломаем

    const decodedHref = decryptLink(e.currentTarget.dataset.url);
    if (!decodedHref) return;

    e.preventDefault();
    window.open(decodedHref, "_blank", "noopener,noreferrer");
  };

  return (
    <span
      className={`external ${className || classLink}`.trim()}
      data-url={encryptedHref}
      onMouseDown={handleClick}
      {...props}
    >
      {children}
    </span>
  );
};

export default LinkHandler;
